export const convertToDecimal = (val, dp = 2) => parseFloat(val).toFixed(dp);
